<div class="accordion-item" [class]="readonly ? 'info-card m-0 p-0' : ''">
    <h2 class="accordion-header m-0">
        <button [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''" class="accordion-button collapsed p-0 p-3" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collars-' + anterior + readonly">
            Collars &nbsp;&nbsp; <span style="font-size: small; color: #707070;">(for tooth {{rearrangedTeethOrderIgnoringBridgedTeeth(teeth)}})</span>
        </button>
    </h2>

     <div id="collars-{{anterior}}{{readonly}}" [class]="!readonly ? 'accordion-collapse collapse' : 'accordion'" >
        <div class="accordion-body container text-center px-3 pt-2">
            <div class="radio-cards-container gap-2 mb-4"  [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''">
                
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == ''">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <div style="height: 80px;">&nbsp;</div>
                    </div>
                    <div class="card-text">No Collar</div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-lingual-collar-a'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-lingual-collar-a" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml1"></app-magnifier>
                        <ng-template #apppropahtml1>
                             <div class="magnify-content">
                            <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'"  [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"    height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Lingual_Collar_a.png" />
                            </div>                                       
                             <div class="card-text">Lingual Collar a)</div>
                             </div>
                        </ng-template>
                    </div>
                   
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-lingual-collar-b'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-lingual-collar-b" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml2"></app-magnifier>
                        <ng-template #apppropahtml2>
                             <div class="magnify-content">
                            <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'" [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"   height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Lingual_Collar_b.png" />
                            </div>
                            <div class="card-text" >Lingual Collar b)</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-circular-collar-a'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-circular-collar-a" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml3"></app-magnifier>
                        <ng-template #apppropahtml3>
                             <div class="magnify-content">
                            <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'" [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"   height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Circular_Collar_a.png" />
                            </div>
                            <div class="card-text">Circular Collar a)</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-circular-collar-b'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-circular-collar-b" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml4"></app-magnifier>
                        <ng-template #apppropahtml4>
                             <div class="magnify-content">
                            <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'" [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"  height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Circular_Collar_b.png" />
                            </div>
                            <div class="card-text">Circular Collar b)</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>

            <!-- </div>

            <div class="radio-cards-container gap-2 mb-4" style="max-width: 51rem; max-height: 9rem;" [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''"> -->
                
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-collar-proximal-contact-a'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-collar-proximal-contact-a" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml5"></app-magnifier>
                        <ng-template #apppropahtml5>
                             <div class="magnify-content">
                                 <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'" [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"   height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Collar_Proximal_Contact_a.png" />
                             </div>
                             <div class="card-text" style="width: 8rem;text-align: center;line-height: 1.2;">Collar Proximal<br /> Contact a)</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-collar-proximal-contact-b'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-collar-proximal-contact-b" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml6"></app-magnifier>
                        <ng-template #apppropahtml6>
                             <div class="magnify-content">
                            <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'" [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"   height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Collar_Proximal_Contact_b.png" />
                            </div>
                             <div class="card-text" style="width: 8rem;text-align: center;line-height: 1.2;">Collar Proximal<br />Contact b)</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-partial-collar-1-2'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-partial-collar-1-2" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml7"></app-magnifier>
                        <ng-template #apppropahtml7>
                             <div class="magnify-content">
                            <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'" [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"   height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Partial_Collar_1-2.png" />
                            </div>
                            <div class="card-text">Partial Collar 1/2</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" *ngIf="!readonly || orderDetailsNew.props['collars'] == 'collars-partial-collar-2-3'">
                    <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="collars-partial-collar-2-3" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml8"></app-magnifier>
                        <ng-template #apppropahtml8>
                             <div class="magnify-content">
                            <div class="img-center">
                            <img [style.height]="readonly ? '110px' : '80px'"  [style.marginTop]="readonly ? '-30px' : '0px'" height="auto"   height="80" src="Asset_Image_Gity\Collar_and_Cutback\Collar\Partial_Collar_1-3.png" />
                            </div>
                            <div class="card-text">Partial Collar 2/3</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                 <!-- <label [style]="readonly ? 'width: 100%' : ''" class="radio-card-label" style="border: none;" *ngIf="!readonly"> -->
                    <!-- <input [disabled]="readonly" type="radio" name="collars-{{anterior}}" [(ngModel)]="orderDetailsNew.props['collars']" value="" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                        <app-magnifier [contentTemplate]="apppropahtml1"></app-magnifier>
                        <ng-template #apppropahtml1>
                            <img width="auto" class="p-3" height="80" src="collars-lingual-collar-a.png" />
                        </ng-template>
                    </div>
                    <div class="card-text"></div>
                    <div class="radio-card-overlay"></div> -->
                <!-- </label> -->

            </div>
           
        </div>
    </div>
</div>

